export const PAYMENT_TYPE_ID = "payment_type_id",
  EXPENSE_TYPE_ID = "expense_type_id",
  AMOUNT = "amount",
  VALUTA_ID = "valuta_id",
  VALUTA_HISTORY_PRICE = "valuta_history_price";
